import { createReducer } from '@reduxjs/toolkit'
import { HierarchyLevels } from 'interfaces/api/promoSettings.interfaces'
import { ValidationErrorsApi } from 'packages/api'
import { createBuilder } from 'packages/redux-toolkit'

import {
  createAllHierarchyLevels,
  getAllHierarchyLevels,
  removeHierarchyLevel,
  setHierarchyLevelsValidationErrors,
  updateHierarchyLevel,
} from './actions'

interface PromoHierarchyLevelsState {
  list: {
    loading: boolean
    items: HierarchyLevels
  }
  single: {
    loading: boolean
    item: string | null
  }
  validation: ValidationErrorsApi | null
}

const initialState: PromoHierarchyLevelsState = {
  list: {
    loading: false,
    items: {
      customerLevel: [],
      productLevel: [],
    },
  },
  single: {
    loading: false,
    item: null,
  },
  validation: null,
}

export const promoHierarchyLevelsReducer = createReducer(initialState, (builder) => {
  createBuilder(builder)
    .addCase(getAllHierarchyLevels.pending, (state) => {
      state.list.loading = true
    })
    .addCase(getAllHierarchyLevels.rejected, (state) => {
      state.list.loading = false
    })
    .addCase(getAllHierarchyLevels.fulfilled, (state, { payload }) => {
      state.list.loading = false
      state.list.items = payload
    })

    .addCase(setHierarchyLevelsValidationErrors, (state, { payload }) => {
      state.validation = payload
    })

    .addCase(
      [createAllHierarchyLevels.pending, removeHierarchyLevel.pending, updateHierarchyLevel.pending],
      (state) => {
        state.list.loading = true
      },
    )
    .addCase(
      [createAllHierarchyLevels.rejected, removeHierarchyLevel.rejected, updateHierarchyLevel.rejected],
      (state) => {
        state.list.loading = false
      },
    )
    .addCase(
      [createAllHierarchyLevels.fulfilled, removeHierarchyLevel.fulfilled, updateHierarchyLevel.fulfilled],
      (state) => {
        state.list.loading = false
      },
    )
})
